const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/404',
    component: Import('error/404'),
    name: 'error_404',
    meta: { title: '404' }
  },
  {
    path: '/h5/500',
    component: Import('error/500'),
    name: 'error_500',
    meta: { title: '500' }
  },
  {
    path: '*',
    component: Import('error/404'),
    name: '404',
    meta: { title: '404' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/error.js